import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 50px;
  @media screen and (max-width: 480px) {
    margin-bottom: 30px;
  }
`;
export const Banner = styled.div`
  width: 100%;
  height: 60vh;
  margin-bottom: 30px;
  position: relative;
  @media screen and (max-width: 480px) {
    height: 40vh;
  }
`;
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Title = styled.p`
  color: white;
  position: absolute;
  left: 100px;
  top: 100px;
  font-size: 40px;
  @media screen and (max-width: 480px) {
    font-size: 18px;
    left: 29px;
    top: 84px;
  }
`;

export const Desc = styled.p`
  width: 40%;
  color: white;
  position: absolute;
  left: 100px;
  top: 160px;
  font-size: 15px;
  font-weight: 200;
  text-align: justify;
  text-justify: inter-word;
  @media screen and (max-width: 480px) {
    font-size: 11px;
    left: 29px;
    top: 132px;
  }
`;

export const SearchSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;
export const Search = styled.div`
  @media screen and (max-width: 480px) {
    display: flex;
    align-items: center;
  }
`;
export const Input = styled.input`
  width: 280px;
  height: 36px;
  outline: none;
  @media screen and (max-width: 480px) {
    width: 130px;
    height: 26px;
  }
`;

export const Button = styled.button`
  height: 36px;
  width: 75px;
  border: none;
  background-color: #2f3133;
  color: white;
  border-radius: 0 5px 5px 0;
  @media screen and (max-width: 480px) {
    width: 38px;
    height: 26px;
    font-size: 8px;
  }
`;
export const Main = styled.div`
  display: flex;
`;

export const BlogList = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto auto auto;
  gap: 30px;
  margin-bottom: 20px;
  @media screen and (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
